'use strict';

// Import Swiper core module.
import Swiper from 'swiper';

// Debounce
import debounce from './debounce.js';

// Import Swiper modules.
// eslint-disable-next-line import/no-unresolved
import { Navigation, Controller, EffectFade, Scrollbar } from 'swiper/modules';

// Configure Swiper to use modules.
Swiper.use([Navigation, Controller, EffectFade, Scrollbar]);

export function defochtelSwiper() {
	/** @type {HTMLElement|null} */
	const sliderSection = document.querySelector('.section-slider');

	if (!sliderSection) {
		return;
	}

	/** @type {Array<HTMLElement>|null} */
	const sliders = document.querySelectorAll('.section-slider');

	for (const slider of sliders) {
		/** @type {HTMLDivElement|null} */
		const thumbsWrapper = slider.querySelector('.section-slider__thumbs');
		/** @type {HTMLDivElement|null} */
		const textWrapper = slider.querySelector('.section-slider__text .swiper');

		// Exit early if one of the elements is not found.
		if (!thumbsWrapper || !textWrapper) {
			return;
		}

		const thumbSwiper = new Swiper(thumbsWrapper, {
			effect: 'fade',
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			loop: false,
			loopAdditionalSlides: 1,
		});

		const textSwiper = new Swiper(textWrapper, {
			effect: 'fade',
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			loop: false,
			loopAdditionalSlides: 1,
			autoHeight: true,
			navigation: {
				prevEl: slider.querySelector('.swiper-button-prev'),
				nextEl: slider.querySelector('.swiper-button-next'),
			},
		});

		if (slider.querySelectorAll('.swiper-slide')?.length <= 1) {
			thumbSwiper.destroy();
			textSwiper.destroy();
		}

		thumbSwiper.controller.control = textSwiper;
		textSwiper.controller.control = thumbSwiper;
	}
}

export function defochtelContentBlock() {
	/** @type {HTMLElement|null} */
	const sectionContentBlock = document.querySelector('.section-content-block');

	if (!sectionContentBlock) {
		return;
	}

	/** @type {Array<HTMLElement>|null} */
	const sectionContentBlocks = document.querySelectorAll('.section-content-block');
	const arr = [];

	sectionContentBlocks.forEach((index) => arr.push('swiper_' + index));

	const init = () => {
		sectionContentBlocks.forEach((section, index) => {
			if (window.innerWidth >= 1024) {
				// eslint-disable-next-line no-unused-vars
				arr['swiper_' + index] = new Swiper(section.querySelector('.swiper'), {
					loop: false,
					centeredSlides: false,
					slidesPerView: 'auto',
					direction: 'vertical',
					spaceBetween: 0,
					scrollbar: {
						// el: section.querySelector('.swiper-scrollbar'),
						el: '.swiper-scrollbar',
					},
					navigation: {
						prevEl: section.querySelector('.swiper-button-prev'),
						nextEl: section.querySelector('.swiper-button-next'),
					},
					slidesOffsetBefore: -28, // px
					slidesOffsetAfter: 151, // px
				});
			} else if (typeof arr['swiper_' + index] !== 'undefined') {
				arr['swiper_' + index].destroy();
			}
		});
	};

	init();

	window.addEventListener('resize', debounce(init));
}

// Assign Swiper to window so Alpine can call on Swiper.
window.Swiper = Swiper;
